(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  onReady(function () {
    var root = document.getElementById('my-orders-root');
    if (!root || root.dataset.ordersReady === 'true') return;
    root.dataset.ordersReady = 'true';

    var LICENSE_PAGE_SIZE = 5;
    var ESIM_PAGE_SIZE = 10;
    var TRAIN_PAGE_SIZE = 10;
    var REQUEST_TIMEOUT = 15000;
    var PAYMENT_POLL_INTERVAL = 3500;
    var PAYMENT_POLL_TIMEOUT = 15 * 60 * 1000;
    var TRAIN_TICKETING_POLL_INTERVAL = 30000;
    var TRAIN_PAYMENT_POLL_TIMEOUT = 30 * 60 * 1000;
    var TRAIN_REFUND_POLICY_URL = 'https://mobile.12306.cn/otsmobile/h5/otsbussiness/info/orderWarmTips.html';
    var UNIFIED_PAGE_SIZE = 20;
    var licenseApi = root.dataset.licenseApi;
    var esimApi = root.dataset.esimApi;
    var trainApi = root.dataset.trainApi;
    var unifiedApi = root.dataset.unifiedApi;

    var STATE_ACTION_HREF = { 'browse-esim': '/pages/esim', 'book-train': '/pages/train-booking' };

    var ICON_ALL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>';
    var ICON_LICENSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.5" cy="11" r="2"/><path d="M13 10h5M13 14h5M5 15.6c.7-1.4 2-2.1 3.5-2.1s2.8.7 3.5 2.1"/></svg>';
    var ICON_ESIM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 3h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/><rect x="8.5" y="11" width="7" height="7" rx="1.4"/><path d="M12 11v7M8.5 14.5h7"/></svg>';
    var ICON_TRAIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 4h8a4 4 0 0 1 4 4v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8a4 4 0 0 1 4-4Z"/><path d="M4 11h16"/><path d="M9 17l-2.5 3M15 17l2.5 3"/><path d="M9 14h.01M15 14h.01"/></svg>';
    var ICON_CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

    var GUIDANCE_LICENSE = '<p class="mo-guidance">Our team emails you from <strong>@driveincnguide.com</strong> within 24 working hours to confirm your application, and the certified translation is delivered by email. Need help? <a href="mailto:service@driveincnguide.com">service@driveincnguide.com</a>.</p>';
    var GUIDANCE_ESIM = '<p class="mo-guidance">Paid orders are prepared automatically and the eSIM QR code is emailed to you. Inventory issue on a paid order? We contact you within 24 hours — or email <a href="mailto:service@driveincnguide.com">service@driveincnguide.com</a>.</p>';
    var GUIDANCE_TRAIN = '<p class="mo-guidance">We email your e-tickets and seat details to the address used at checkout. Ticketing can take from a few minutes to several hours — check back here for the latest status, or email <a href="mailto:service@driveincnguide.com">service@driveincnguide.com</a>.</p>';

    // Switcher
    var switcher = root.querySelector('[data-switcher]');
    var switcherTrigger = root.querySelector('[data-switcher-trigger]');
    var switcherIcon = root.querySelector('[data-switcher-icon]');
    var switcherLabel = root.querySelector('[data-switcher-label]');
    var switcherSubtitle = root.querySelector('[data-switcher-subtitle]');
    var switcherList = root.querySelector('[data-switcher-list]');
    var switcherOptions = [];

    // Identity panels (shared email form + login card)
    var identityPanels = Array.prototype.slice.call(root.querySelectorAll('[data-identity-panel]'));
    var emailForm = root.querySelector('[data-license-form]');
    var emailInput = root.querySelector('[data-license-email]');
    var emailError = root.querySelector('[data-license-email-error]');
    var emailSubmit = root.querySelector('[data-license-submit]');
    var accountLoginState = root.querySelector('[data-account-login-state]');
    var accountLoginButton = root.querySelector('[data-account-login]');
    var accountSummary = root.querySelector('[data-account-summary]');
    var accountEmail = root.querySelector('[data-account-email]');
    var accountRefresh = root.querySelector('[data-account-refresh]');
    var accountPanelTitle = root.querySelector('[data-account-panel-title]');
    var accountLoginTitle = root.querySelector('[data-account-login-title]');
    var accountLoginCopy = root.querySelector('[data-account-login-copy]');

    var results = root.querySelector('.mo-results');
    var resultsTitle = root.querySelector('[data-results-title]');
    var resultsSummary = root.querySelector('[data-results-summary]');
    var resultsStatus = root.querySelector('[data-results-status]');
    var orderList = root.querySelector('[data-order-list]');
    var orderHelp = root.querySelector('[data-order-help]');
    var pagination = root.querySelector('[data-order-pagination]');
    var pagePrev = root.querySelector('[data-page-prev]');
    var pageNext = root.querySelector('[data-page-next]');
    var pageLabel = root.querySelector('[data-page-label]');
    var modal = root.querySelector('[data-order-modal]');
    var modalDialog = root.querySelector('[data-order-modal-dialog]');
    var modalContent = root.querySelector('[data-order-modal-content]');
    var modalClose = root.querySelector('[data-order-modal-close]');

    if (!emailForm || !results || !orderList || !modal || !modalDialog) return;

    /* ---------- Generic helpers ---------- */

    function element(tagName, className, text) {
      var node = document.createElement(tagName);
      if (className) node.className = className;
      if (text !== undefined && text !== null) node.textContent = String(text);
      return node;
    }

    function append(parent) {
      for (var i = 1; i < arguments.length; i += 1) {
        if (arguments[i]) parent.appendChild(arguments[i]);
      }
      return parent;
    }

    function stringValue(value) {
      return value === null || value === undefined ? '' : String(value).trim();
    }

    function pick(record, keys) {
      if (!record) return '';
      for (var i = 0; i < keys.length; i += 1) {
        var value = record[keys[i]];
        if (value !== undefined && value !== null && value !== '') return value;
      }
      return '';
    }

    function safeHttpUrl(value) {
      if (!value) return '';
      try {
        var url = new URL(String(value), window.location.origin);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url.toString() : '';
      } catch (error) {
        return '';
      }
    }

    function paypalUrl(value) {
      var safe = safeHttpUrl(value);
      if (!safe) return '';
      try {
        var url = new URL(safe);
        if (url.protocol !== 'https:') return '';
        if (!/(^|\.)paypal\.com$/i.test(url.hostname)) return '';
        return url.toString();
      } catch (error) {
        return '';
      }
    }

    function formatCurrency(value, currency) {
      var amount = Number(value);
      if (!Number.isFinite(amount)) return '';
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency || 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    function formatDate(value) {
      if (!value) return '';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      try {
        return new Intl.DateTimeFormat('en', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }).format(date);
      } catch (error) {
        return String(value);
      }
    }

    function formatDateOnly(value) {
      var raw = stringValue(value);
      if (!raw) return '';
      var normalized = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw + 'T00:00:00' : raw;
      var date = new Date(normalized);
      if (Number.isNaN(date.getTime())) return raw;
      try {
        return new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: 'numeric' }).format(date);
      } catch (error) {
        return raw;
      }
    }

    function enumLabel(value) {
      return stringValue(value)
        .toLowerCase()
        .split('_')
        .filter(Boolean)
        .map(function (part) { return part.charAt(0).toUpperCase() + part.slice(1); })
        .join(' ');
    }

    function plural(count, singular, pluralValue) {
      return count + ' ' + (count === 1 ? singular : (pluralValue || singular + 's'));
    }

    function apiError(message, code, status) {
      var error = new Error(message || 'The order service returned an error.');
      error.code = Number(code) || 0;
      error.status = Number(status) || 0;
      return error;
    }

    function errorCode(error) {
      var businessCode = Number(error && error.code) || 0;
      if (businessCode && businessCode !== 200) return businessCode;
      return Number(error && error.status) || businessCode;
    }

    function statusBadge(record, desc) {
      var status = desc.statusOf(record);
      var label = desc.statusLabelOf(record);
      var tone = desc.statusTone(status, record);
      var className = 'mo-status' + (tone === 'neutral' ? '' : ' mo-status--' + tone);
      return element('span', className, label || enumLabel(status) || 'Processing');
    }

    function addFact(list, label, value, extraClass) {
      if (value === '' || value === null || value === undefined) return;

      // 支持对象格式的复杂显示（用于优惠券信息）
      if (typeof value === 'object' && value !== null && value.formatted !== undefined) {
        // 原价行
        if (value.original) {
          var originalItem = element('div', 'mo-order-fact' + (extraClass ? ' ' + extraClass : ''));
          append(originalItem, element('dt', '', 'Original price'), element('dd', '', value.original));
          list.appendChild(originalItem);
        }
        // 折扣行
        if (value.discount && value.couponName) {
          var discountItem = element('div', 'mo-order-fact mo-order-fact--discount');
          var discountText = 'Coupon (' + value.couponName + ')';
          append(discountItem, element('dt', '', discountText), element('dd', '', '-' + value.discount));
          list.appendChild(discountItem);
        }
        // 实付金额行
        var totalItem = element('div', 'mo-order-fact' + (extraClass ? ' ' + extraClass : ''));
        append(totalItem, element('dt', '', value.label || label), element('dd', '', value.formatted));
        list.appendChild(totalItem);
        return;
      }

      // 常规字符串显示
      var item = element('div', 'mo-order-fact' + (extraClass ? ' ' + extraClass : ''));
      append(item, element('dt', '', label), element('dd', '', value));
      list.appendChild(item);
    }

    function detailRow(label, value) {
      if (value === '' || value === null || value === undefined) return null;
      var item = element('div', 'mo-detail-row');
      append(item, element('dt', '', label), element('dd', '', value));
      return item;
    }

    function detailSection(title, pairs) {
      var section = element('section', 'mo-detail-section');
      var list = element('dl', 'mo-detail-list');
      pairs.forEach(function (pair) {
        var row = detailRow(pair[0], pair[1]);
        if (row) list.appendChild(row);
      });
      if (!list.children.length) return null;
      append(section, element('h3', '', title), list);
      return section;
    }

    async function requestJson(url, options, requestKey) {
      var config = options || {};
      if (requestControllers[requestKey]) requestControllers[requestKey].abort();
      var controller = new AbortController();
      requestControllers[requestKey] = controller;
      var timeout = window.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT);
      var response;

      try {
        response = await window.fetch(url, {
          method: config.method || 'GET',
          headers: config.headers || { Accept: 'application/json' },
          body: config.body,
          signal: controller.signal
        });
      } catch (error) {
        if (error && error.name === 'AbortError') {
          throw apiError('The request took too long. Check your connection and try again.', 408, 408);
        }
        throw apiError('Unable to reach the order service. Check your connection and try again.');
      } finally {
        window.clearTimeout(timeout);
        if (requestControllers[requestKey] === controller) requestControllers[requestKey] = null;
      }

      var payload;
      try {
        payload = await response.json();
      } catch (error) {
        throw apiError('The order service returned an unexpected response.', response.status, response.status);
      }

      if (!response.ok || !payload || payload.code !== 200) {
        throw apiError(payload && payload.msg, payload && payload.code, response.status);
      }
      return payload;
    }

    function friendlyError(error, desc) {
      var code = errorCode(error);
      if (code === 401) return 'Your session has expired. Log in again to view your orders.';
      if (code === 403) return 'This account cannot access that order.';
      if (code === 404) return 'We could not find that order.';
      if (code === 408) return 'The request timed out. Check your connection, then try again.';
      if (code >= 500) return 'The order service is temporarily unavailable. Try again shortly.';
      return stringValue(error && error.message) || desc.errorFallback;
    }

    function getAuth() {
      return window.TripCNAuth && typeof window.TripCNAuth.getState === 'function'
        ? window.TripCNAuth
        : null;
    }

    function getAccessToken() {
      var auth = getAuth();
      return auth && typeof auth.getAccessToken === 'function' ? auth.getAccessToken() : '';
    }

    /* ---------- Train helpers ---------- */

    function trainRoute(record) {
      var from = pick(record, ['fromStationName', 'departureStationName', 'startStationName', 'fromStation']);
      var to = pick(record, ['toStationName', 'arriveStationName', 'arrivalStationName', 'endStationName', 'toStation']);
      if (from && to) return from + ' → ' + to;
      return from || to || '';
    }

    function trainPassengerCount(record) {
      if (Array.isArray(record.passengers) && record.passengers.length) return String(record.passengers.length);
      var count = pick(record, ['passengerCount', 'ticketCount']);
      return count === '' ? '' : String(count);
    }

    function trainTotal(record) {
      var amount = pick(record, ['totalPrice', 'totalAmount', 'totalUsd', 'orderAmount', 'payAmount']);
      var discount = pick(record, ['discountAmount']);
      var original = pick(record, ['originalPrice']);

      // 如果有折扣金额且大于0，显示为"原价 - 折扣 = 实付"的格式
      if (discount !== '' && Number(discount) > 0) {
        var currency = pick(record, ['currency']) || 'USD';
        var originalFormatted = original !== '' ? formatCurrency(original, currency) : '';
        var discountFormatted = formatCurrency(discount, currency);
        var totalFormatted = amount !== '' ? formatCurrency(amount, currency) : '';
        // 返回对象让 addFact 支持复杂显示
        return {
          formatted: totalFormatted,
          label: 'Total',
          original: originalFormatted,
          discount: discountFormatted,
          couponName: pick(record, ['couponName'])
        };
      }

      if (amount !== '') return formatCurrency(amount, pick(record, ['currency']) || 'USD');
      var cny = pick(record, ['ticketPriceCny', 'totalCny']);
      if (cny !== '') return formatCurrency(cny, 'CNY');
      return '';
    }

    function appendTrainPassengers(fragment, passengers) {
      var list = Array.isArray(passengers) ? passengers : [];
      if (!list.length) return;
      var section = element('section', 'mo-detail-section');
      section.appendChild(element('h3', '', 'Passengers'));
      var wrap = element('div', 'mo-passenger-list');
      list.forEach(function (passenger, index) {
        var item = element('div', 'mo-passenger');
        var top = element('div', 'mo-passenger__top');
        top.appendChild(element('strong', 'mo-passenger__name', passenger.passengerName || ('Passenger ' + (index + 1))));
        var status = stringValue(passenger.ticketStatus).toUpperCase();
        var statusLabel = status === 'SUCCESS' ? 'Ticket issued' : status === 'FAILED' ? 'Ticket failed' : 'Processing';
        var tone = status === 'SUCCESS' ? 'success' : status === 'FAILED' ? 'danger' : 'warning';
        top.appendChild(element('span', 'mo-status mo-status--' + tone, statusLabel));
        item.appendChild(top);
        var seat = [
          passenger.coachNo ? 'Coach ' + passenger.coachNo : '',
          passenger.seatNo ? 'Seat ' + passenger.seatNo : '',
          passenger.ticketNo ? 'Ticket ' + passenger.ticketNo : ''
        ].filter(Boolean).join(' · ');
        var detail = status === 'SUCCESS'
          ? (seat || 'Seat details will be sent by email.')
          : (stringValue(passenger.failReason) || 'The latest result appears here once processing completes.');
        item.appendChild(element('p', 'mo-passenger__detail', detail));
        wrap.appendChild(item);
      });
      section.appendChild(wrap);
      fragment.appendChild(section);
    }

    function appendTravelerDetails(fragment, travelers) {
      travelers.forEach(function (traveler, index) {
        var section = element('section', 'mo-detail-section');
        var name = traveler.name || traveler.chineseName || 'Traveler ' + (index + 1);
        section.appendChild(element('h3', '', name));
        var grid = element('div', 'mo-photo-grid');
        [
          ['Driver license (front)', traveler.frontUrl],
          ['Driver license (back)', traveler.backUrl],
          ['Passport', traveler.passportUrl],
          ['China visa', traveler.visaUrl]
        ].forEach(function (photo) {
          var url = safeHttpUrl(photo[1]);
          if (!url) return;
          var link = element('a', 'mo-photo-link');
          link.href = url;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          var image = document.createElement('img');
          image.src = url;
          image.alt = photo[0] + ' for ' + name;
          image.loading = 'lazy';
          append(link, element('span', '', photo[0]), image);
          grid.appendChild(link);
        });
        if (grid.children.length) {
          section.appendChild(grid);
          fragment.appendChild(section);
        }
      });
    }

    function licenseOrder(record) {
      return (record && record.order) || {};
    }

    /* ---------- Business registry ---------- */

    var licenseBusiness = {
      id: 'license',
      label: 'Driver’s License',
      subtitle: 'Permit and translation orders',
      icon: ICON_LICENSE,
      identity: 'email',
      pageSize: LICENSE_PAGE_SIZE,
      resultsTitle: 'Temporary Driver’s License orders',
      loadingSummary: 'Searching your order history…',
      errorFallback: 'We could not search your driver’s license orders. Try again.',
      guidanceHTML: GUIDANCE_LICENSE,
      idleState: {
        summary: 'Enter your order email to begin.',
        title: 'Find your order history.',
        message: 'Enter the email used at checkout, then select Search orders.'
      },
      emptyState: {
        title: 'No orders found for this email.',
        message: 'Check the email spelling or try another address used at checkout.'
      },
      load: function (page) { return runLoad(licenseBusiness, page); },
      request: function (page) {
        return requestJson(licenseApi, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: state.license.email, pageNum: page, pageSize: LICENSE_PAGE_SIZE })
        }, 'license');
      },
      parse: function (payload, page) {
        var records = Array.isArray(payload.data) ? payload.data : [];
        var total = Number(payload.total) || 0;
        var pages = total > 0
          ? Math.max(1, Math.ceil(total / LICENSE_PAGE_SIZE))
          : (records.length === LICENSE_PAGE_SIZE ? page + 1 : page);
        return { records: records, total: total || records.length, pages: pages, current: page };
      },
      statusOf: function (record) { return licenseOrder(record).financialStatus; },
      statusLabelOf: function (record) { return licenseOrder(record).financialStatus || 'Processing'; },
      statusTone: function (status) {
        var value = stringValue(status).toUpperCase();
        return value === 'PAID' || value === 'FULFILLED' ? 'success' : 'warning';
      },
      cardService: function (record) { return licenseOrder(record).serviceType || 'Temporary Driver’s License'; },
      cardTitle: function (record) {
        var order = licenseOrder(record);
        var number = order.orderId || order.orderNo || '';
        return number ? 'Order #' + number : 'Order details';
      },
      renderCard: function (record, data) {
        var order = licenseOrder(record);
        addFact(data, 'Total', formatCurrency(order.totalPrice, order.currency || 'USD'), 'mo-order-fact--price');
        addFact(data, 'Service', order.serviceType);
        addFact(data, 'Quantity', order.quantity);
        addFact(data, 'Ordered', formatDate(order.createTime || order.createdAt));
      },
      renderDetail: function (record, fragment) {
        var order = licenseOrder(record);
        append(fragment, detailSection('Order summary', [
          ['Total', formatCurrency(order.totalPrice, order.currency || 'USD')],
          ['Service type', order.serviceType],
          ['Quantity', order.quantity],
          ['Created at', formatDate(order.createTime || order.createdAt)],
          ['Fulfillment status', order.fulfillmentStatus],
          ['Note', order.note]
        ]));
        append(fragment, detailSection('Customer and application', [
          ['Customer name', order.customerName || [order.firstName, order.lastName].filter(Boolean).join(' ')],
          ['Email', order.email],
          ['Phone', order.phone],
          ['Nationality', order.nationality],
          ['License issued in', order.licenseIssued || order.licenseIssuedCountry],
          ['Application city', order.applyCity || order.city],
          ['Driver email', order.driverEmail]
        ]));
        appendTravelerDetails(fragment, record.travelerList || []);
      }
    };

    var esimBusiness = {
      id: 'esim',
      label: 'eSIM',
      subtitle: 'Data plans and delivery',
      icon: ICON_ESIM,
      identity: 'email',
      pageSize: ESIM_PAGE_SIZE,
      resultsTitle: 'eSIM orders',
      loadingSummary: 'Searching your eSIM orders…',
      errorFallback: 'We could not search your eSIM orders. Try again.',
      guidanceHTML: GUIDANCE_ESIM,
      idleState: {
        summary: 'Enter your order email to begin.',
        title: 'Find your eSIM orders.',
        message: 'Enter the email used at checkout, then select Search orders.'
      },
      emptyState: {
        title: 'No eSIM orders found for this email.',
        message: 'Check the email spelling or try another address used at checkout.',
        actionLabel: 'Browse eSIM plans',
        action: 'browse-esim'
      },
      load: function (page) { return runLoad(esimBusiness, page); },
      request: function () {
        var email = state.esim.email;
        if (!email) return Promise.reject(apiError('Email is required.', 400, 400));
        var url = unifiedApi + '/all-by-email?email=' + encodeURIComponent(email);
        return requestJson(url, {}, 'esim');
      },
      parse: function (payload) {
        var data = payload.data || payload || {};
        var records = Array.isArray(data.esimOrders) ? data.esimOrders : [];
        return { records: records, total: records.length, pages: 1, current: 1 };
      },
      statusOf: function (record) { return record.status; },
      statusLabelOf: function (record) { return record.statusLabelEn || record.statusLabel || enumLabel(record.status); },
      statusTone: function (status) {
        var value = stringValue(status).toUpperCase();
        if (['PAID', 'DELIVERED'].indexOf(value) !== -1) return 'success';
        if (['PENDING_PAYMENT', 'PENDING_REVIEW', 'PAID_NO_STOCK'].indexOf(value) !== -1) return 'warning';
        if (['EXPIRED', 'REJECTED', 'CANCELLED'].indexOf(value) !== -1) return 'danger';
        return 'neutral';
      },
      cardService: function (record) { return record.productName || 'eSIM plan'; },
      cardTitle: function (record) {
        var number = record.orderNo || record.referenceId || '';
        return number ? 'Order #' + number : 'Order details';
      },
      cardAlert: function (record) {
        return record.status === 'PAID_NO_STOCK'
          ? 'Payment was received, but inventory is temporarily unavailable. Our support team will contact you within 24 hours.'
          : '';
      },
      cardActions: function (record, index) {
        if (!record.canPay) return null;
        var approveUrl = safeHttpUrl(record.approveUrl);
        if (!approveUrl) return null;
        var payButton = element('button', 'mo-button mo-button--primary', 'Complete payment');
        payButton.type = 'button';
        payButton.dataset.orderPayment = String(index);
        return [payButton];
      },
      renderCard: function (record, data) {
        addFact(data, 'Data plan', record.dataDisplay || record.productName);
        addFact(data, 'Duration', record.selectedDays
          ? plural(Number(record.selectedDays), 'day')
          : (record.validityDays ? plural(Number(record.validityDays), 'day') : ''));
        var discount = pick(record, ['discountAmount']);
        var original = pick(record, ['originalPrice']);
        if (discount !== '' && Number(discount) > 0) {
          addFact(data, 'Original price', formatCurrency(original, record.currency), 'mo-order-fact--price');
          var couponName = pick(record, ['couponName']) || '';
          addFact(data, 'Coupon (' + couponName + ')', '-' + formatCurrency(discount, record.currency), 'mo-order-fact--discount');
          addFact(data, 'Total', formatCurrency(record.totalPrice, record.currency), 'mo-order-fact--price');
        } else {
          addFact(data, 'Total', formatCurrency(record.totalPrice, record.currency), 'mo-order-fact--price');
        }
        addFact(data, 'Ordered', formatDate(record.createdAt));
      },
      hydrateDetail: function (record, index, desc) {
        if (!record.orderNo) return Promise.resolve();
        var token = getAccessToken();
        if (!token) return Promise.resolve();
        detailRequestId += 1;
        var requestId = detailRequestId;
        return requestJson(
          esimApi + '/api/v1/esim/orders/' + encodeURIComponent(record.orderNo),
          { headers: { Accept: 'application/json', Authorization: 'Bearer ' + token } },
          'detail'
        ).then(function (payload) {
          if (requestId !== detailRequestId || modal.hidden || !modalContext) return;
          state.esim.records[index] = payload.data || record;
          renderModalDetails(state.esim.records[index], desc);
        }).catch(function () {
          /* The list response already contains a complete displayable record. */
        });
      },
      renderDetail: function (record, fragment) {
        var summaryDetails = [
          ['Reference ID', record.referenceId],
          ['Created at', formatDate(record.createdAt)],
          ['Paid at', formatDate(record.paidAt)],
          ['Delivered at', formatDate(record.deliveredAt)]
        ];
        var originalPrice = pick(record, ['originalPrice']);
        var discountAmount = pick(record, ['discountAmount']);
        if (originalPrice !== '') {
          summaryDetails.push(['Original price', formatCurrency(originalPrice, record.currency)]);
        }
        if (discountAmount !== '' && Number(discountAmount) > 0) {
          var couponName = pick(record, ['couponName']) || '';
          summaryDetails.push(['Coupon discount (' + couponName + ')', '-' + formatCurrency(discountAmount, record.currency)]);
        }
        summaryDetails.push(['Total', formatCurrency(record.totalPrice, record.currency)]);
        summaryDetails.push(['Quantity', record.quantity]);
        append(fragment, detailSection('Order summary', summaryDetails));
        append(fragment, detailSection('eSIM plan', [
          ['Product', record.productName],
          ['Region', record.regionName || record.regionCode],
          ['Data', record.dataDisplay],
          ['Selected duration', record.selectedDays ? plural(Number(record.selectedDays), 'day') : ''],
          ['Plan validity', record.validityDays ? plural(Number(record.validityDays), 'day') : ''],
          ['SKU', record.sku]
        ]));
        append(fragment, detailSection('Delivery and payment', [
          ['Customer email', record.customerEmail],
          ['Recipient email', record.recipientEmail || record.customerEmail],
          ['PayPal order ID', record.paypalOrderId],
          ['ICCID', record.assignedIccid],
          ['Notes', record.notes]
        ]));
      }
    };

    var trainBusiness = {
      id: 'train',
      label: 'High-speed rail',
      subtitle: 'Train tickets and seats',
      icon: ICON_TRAIN,
      identity: 'login',
      accountLoginTitle: 'Log in to view high-speed rail orders',
      accountLoginCopy: 'Train orders are linked to the account used at checkout.',
      pageSize: TRAIN_PAGE_SIZE,
      resultsTitle: 'High-speed rail orders',
      loadingSummary: 'Loading your train orders…',
      errorFallback: 'We could not load your train orders. Try again.',
      guidanceHTML: GUIDANCE_TRAIN,
      idleState: {
        summary: 'Log in to view your train orders.',
        title: 'Your train orders will appear here.',
        message: 'Log in with the same email used at checkout to view your orders.'
      },
      emptyState: {
        title: 'No train orders yet.',
        message: 'Train orders linked to this account will appear here.',
        actionLabel: 'Book a train',
        action: 'book-train'
      },
      authState: {
        title: 'Your train orders are linked to your account.',
        message: 'Log in with the same email used at checkout to view your train tickets and seat details.',
        actionLabel: 'Log in',
        action: 'login'
      },
      load: function (page) { return runLoad(trainBusiness, page); },
      ensure: function () {
        var st = state.train;
        if (!state.authReady) {
          if (st.phase !== 'checking') st.phase = 'checking';
          renderResults();
          return;
        }
        if (!state.authUser) {
          st.phase = 'auth';
          renderResults();
          return;
        }
        if (st.phase === 'checking' || st.phase === 'auth' || st.phase === 'idle') runLoad(trainBusiness, 1);
      },
      request: function (page) {
        var token = getAccessToken();
        if (!token || !state.authUser) return Promise.reject(apiError('Log in to view your train orders.', 401, 401));
        var url = trainApi + '/my-orders?pageNo=' + encodeURIComponent(page) +
          '&pageSize=' + TRAIN_PAGE_SIZE;
        return requestJson(
          url,
          { headers: { Accept: 'application/json', Authorization: 'Bearer ' + token } },
          'train'
        );
      },
      parse: function (payload, page) {
        var data = payload.data;
        var records = [];
        var total;
        var pages;
        var current;
        if (Array.isArray(data)) {
          records = data;
        } else if (data && Array.isArray(data.records)) {
          records = data.records;
          total = Number(data.total);
          pages = Number(data.pages);
          current = Number(data.current);
        } else if (Array.isArray(payload.records)) {
          records = payload.records;
          total = Number(payload.total);
        }
        if (!Number.isFinite(total) || total < 0) total = records.length;
        if (!Number.isFinite(pages) || pages < 1) {
          pages = total > records.length
            ? Math.max(1, Math.ceil(total / TRAIN_PAGE_SIZE))
            : (records.length === TRAIN_PAGE_SIZE ? page + 1 : page);
        }
        return { records: records, total: total, pages: pages, current: current || page };
      },
      statusOf: function (record) { return record.status; },
      statusLabelOf: function (record) { return record.statusDesc || enumLabel(record.status) || 'Processing'; },
      statusTone: function (status) {
        var value = stringValue(status).toUpperCase();
        if (['TICKETED', 'REFUNDED'].indexOf(value) !== -1) return 'success';
        if (['PENDING_PAYMENT', 'PAID', 'SUBMITTED', 'WAITLIST', 'REFUND_PENDING'].indexOf(value) !== -1) return 'warning';
        if (['TICKET_FAILED', 'SUBMIT_FAILED', 'REFUND_FAILED', 'EXPIRED', 'CANCELLED', 'CANCELED'].indexOf(value) !== -1) return 'danger';
        return 'neutral';
      },
      cardService: function () { return 'High-speed rail'; },
      cardTitle: function (record) {
        var number = record.orderNo || record.orderId || '';
        return number ? 'Order #' + number : 'Train order';
      },
      cardActions: function (record, index) {
        var actions = [];
        var approveUrl = paypalUrl(record.approveUrl);
        if (record.canPay && approveUrl) {
          var payButton = element('button', 'mo-button mo-button--primary', 'Continue payment');
          payButton.type = 'button';
          payButton.dataset.orderPayment = String(index);
          actions.push(payButton);
        }
        if (record.canRefund && !record.refundUnderReview) {
          var refundButton = element('button', 'mo-button mo-button--secondary', 'Request refund');
          refundButton.type = 'button';
          refundButton.dataset.orderRefund = String(index);
          actions.push(refundButton);
        }
        return actions.length ? actions : null;
      },
      cardAlert: function (record) {
        if (record.refundUnderReview) return 'Your refund request is under review.';
        if (record.paymentExpired) return 'This payment link has expired. Please place a new order.';
        return stringValue(record.failReason);
      },
      renderCard: function (record, data) {
        addFact(data, 'Route', trainRoute(record));
        addFact(data, 'Train', pick(record, ['trainCode', 'trainNo', 'trainNumber']));
        addFact(data, 'Date', formatDateOnly(pick(record, ['trainDate', 'departDate', 'travelDate'])));
        addFact(data, 'Seat', pick(record, ['seatTypeName', 'seatName']));
        addFact(data, 'Passengers', trainPassengerCount(record));
        var total = trainTotal(record);
        if (typeof total === 'object' && total !== null) {
          // 有优惠券折扣时逐行显示
          if (total.original) addFact(data, 'Original price', total.original);
          if (total.discount && total.couponName) {
            addFact(data, 'Coupon (' + total.couponName + ')', '-' + total.discount, 'mo-order-fact--discount');
          }
          addFact(data, 'Total', total.formatted, 'mo-order-fact--price');
        } else {
          addFact(data, 'Total', total, 'mo-order-fact--price');
        }
      },
      renderDetail: function (record, fragment) {
        var details = [
          ['Route', trainRoute(record)],
          ['Train', pick(record, ['trainCode', 'trainNo', 'trainNumber'])],
          ['Travel date', formatDateOnly(pick(record, ['trainDate', 'departDate', 'travelDate']))],
          ['Departs', formatDate(pick(record, ['trainStartTime', 'departTime', 'departureTime']))],
          ['Arrives', formatDate(pick(record, ['trainArriveTime', 'arriveTime', 'arrivalTime']))],
          ['Seat class', pick(record, ['seatTypeName', 'seatName'])],
          ['Total', trainTotal(record)],
          ['Status', trainBusiness.statusLabelOf(record)]
        ];
        var couponName = pick(record, ['couponName']);
        var discountAmount = pick(record, ['discountAmount']);
        var originalPrice = pick(record, ['originalPrice']);
        if (originalPrice !== '') {
          details.splice(details.length - 2, 0, ['Original price', formatCurrency(originalPrice, pick(record, ['currency']) || 'USD')]);
        }
        if (discountAmount !== '' && Number(discountAmount) > 0) {
          details.splice(details.length - 2, 0, [
            'Coupon discount (' + (couponName || '') + ')',
            '-' + formatCurrency(discountAmount, pick(record, ['currency']) || 'USD')
          ]);
        }
        append(fragment, detailSection('Trip summary', details));
        append(fragment, detailSection('Contact', [
          ['Name', pick(record, ['contactName'])],
          ['Email', pick(record, ['contactEmail', 'email'])],
          ['Phone', pick(record, ['contactPhone', 'phone'])],
          ['Order reference', pick(record, ['orderNo', 'orderId'])],
          ['Placed', formatDate(pick(record, ['createdAt', 'createTime']))]
        ]));
        var failReason = pick(record, ['failReason']);
        if (failReason) {
          var failSection = element('section', 'mo-detail-section');
          append(failSection, element('h3', '', 'Order update'), element('p', 'mo-order-alert', failReason));
          fragment.appendChild(failSection);
        }
        appendTrainPassengers(fragment, record.passengers);
      },
      hydrateDetail: function (record, index, desc) {
        if (!record.orderNo) return Promise.resolve();
        var token = getAccessToken();
        if (!token) return Promise.resolve();
        detailRequestId += 1;
        var requestId = detailRequestId;
        return requestJson(
          trainApi + '/orders/' + encodeURIComponent(record.orderNo),
          { headers: { Accept: 'application/json', Authorization: 'Bearer ' + token } },
          'detail'
        ).then(function (payload) {
          if (requestId !== detailRequestId || modal.hidden || !modalContext) return;
          state.train.records[index] = payload.data || record;
          renderModalDetails(state.train.records[index], desc);
        }).catch(function () {
          /* The paginated list already contains a complete displayable record. */
        });
      }
    };

    var unifiedBusiness = {
      id: 'all',
      label: 'All Orders',
      subtitle: 'All services combined',
      icon: ICON_ALL,
      identity: 'login',
      accountLoginTitle: 'Log in to view all your orders',
      accountLoginCopy: 'See your Driver’s License, eSIM and train orders together in one place.',
      pageSize: UNIFIED_PAGE_SIZE,
      resultsTitle: 'All orders',
      loadingSummary: 'Searching all orders…',
      errorFallback: 'We could not search your orders. Try again.',
      guidanceHTML: '<p class="mo-guidance">View all your orders across Driver’s License, eSIM, and Train tickets in one place.</p>',
      idleState: {
        summary: 'Log in to view your orders.',
        title: 'View all your orders in one place.',
        message: 'Log in to see your complete order history across all services.'
      },
      emptyState: {
        title: 'No orders found for this account.',
        message: 'Orders placed with this account or login email will appear here.'
      },
      authState: {
        title: 'Your combined order history is linked to your account.',
        message: 'Log in with the same email used at checkout to see your Driver’s License, eSIM and train orders together.',
        actionLabel: 'Log in',
        action: 'login'
      },
      load: function (page) { return runLoad(unifiedBusiness, page); },
      ensure: function () {
        var st = state.all;
        if (!state.authReady) {
          if (st.phase !== 'checking') st.phase = 'checking';
          renderResults();
          return;
        }
        if (!state.authUser) {
          st.phase = 'auth';
          renderResults();
          return;
        }
        if (st.phase === 'checking' || st.phase === 'auth' || st.phase === 'idle') runLoad(unifiedBusiness, 1);
      },
      request: function () {
        var email = state.authUser && state.authUser.email;
        if (!email) return Promise.reject(apiError('Log in to view your orders.', 401, 401));
        var url = unifiedApi + '/all-by-email?email=' + encodeURIComponent(email);
        return requestJson(url, {}, 'unified');
      },
      parse: function (payload) {
        var data = payload.data || payload;
        var allRecords = [];

        // Parse travel bookings (Driver's License)
        if (data.travelBookings && Array.isArray(data.travelBookings)) {
          data.travelBookings.forEach(function (item) {
            allRecords.push({
              _type: 'license',
              _source: item,
              orderNo: item.order && item.order.orderNo,
              status: item.order && item.order.status,
              createdAt: item.order && item.order.createTime,
              totalPrice: item.order && item.order.totalPrice
            });
          });
        }

        // Parse eSIM orders
        if (data.esimOrders && Array.isArray(data.esimOrders)) {
          data.esimOrders.forEach(function (item) {
            allRecords.push({
              _type: 'esim',
              _source: item,
              orderNo: item.orderNo || item.referenceId,
              status: item.status,
              createdAt: item.createdAt,
              totalPrice: item.totalPrice
            });
          });
        }

        // Parse train orders
        if (data.trainOrders && Array.isArray(data.trainOrders)) {
          data.trainOrders.forEach(function (item) {
            allRecords.push({
              _type: 'train',
              _source: item,
              orderNo: item.orderNo || item.orderId,
              status: item.status,
              createdAt: item.createdAt || item.createTime,
              totalPrice: item.totalPriceUsd || item.totalPrice
            });
          });
        }

        // Sort by creation date, newest first
        allRecords.sort(function (a, b) {
          var dateA = new Date(a.createdAt || 0);
          var dateB = new Date(b.createdAt || 0);
          return dateB - dateA;
        });

        return {
          records: allRecords,
          total: allRecords.length,
          pages: 1,
          current: 1
        };
      },
      statusOf: function (record) {
        return record._source && record._source.status;
      },
      statusLabelOf: function (record) {
        var type = record._type;
        var source = record._source;
        if (type === 'license') return source.order && source.order.status;
        if (type === 'esim') return source.statusLabelEn || source.statusLabel || enumLabel(source.status);
        if (type === 'train') return source.statusDesc || enumLabel(source.status);
        return 'Unknown';
      },
      statusTone: function (status, record) {
        var type = record._type;
        if (type === 'license') return licenseBusiness.statusTone(status);
        if (type === 'esim') return esimBusiness.statusTone(status);
        if (type === 'train') return trainBusiness.statusTone(status);
        return 'neutral';
      },
      cardService: function (record) {
        var type = record._type;
        if (type === 'license') return 'Driver’s License';
        if (type === 'esim') return 'eSIM';
        if (type === 'train') return 'High-speed rail';
        return 'Order';
      },
      cardTitle: function (record) {
        var number = record.orderNo;
        return number ? 'Order #' + number : 'Order details';
      },
      cardAlert: function (record) {
        var type = record._type;
        var source = record._source;
        if (type === 'esim') return esimBusiness.cardAlert(source);
        if (type === 'train') return trainBusiness.cardAlert(source);
        return '';
      },
      cardActions: function (record, index) {
        var type = record._type;
        var source = record._source;
        if (type === 'esim') return esimBusiness.cardActions(source, index);
        if (type === 'train') return trainBusiness.cardActions(source, index);
        return null;
      },
      renderCard: function (record, data) {
        var type = record._type;
        var source = record._source;
        if (type === 'license') {
          licenseBusiness.renderCard(source, data);
        } else if (type === 'esim') {
          esimBusiness.renderCard(source, data);
        } else if (type === 'train') {
          trainBusiness.renderCard(source, data);
        }
      },
      hydrateDetail: function (record, index) {
        var type = record._type;
        var source = record._source;
        if (!source || !source.orderNo) return Promise.resolve();
        var token = getAccessToken();
        if (!token) return Promise.resolve();

        var url;
        if (type === 'esim') {
          url = esimApi + '/api/v1/esim/orders/' + encodeURIComponent(source.orderNo);
        } else if (type === 'train') {
          url = trainApi + '/orders/' + encodeURIComponent(source.orderNo);
        } else {
          return Promise.resolve();
        }

        detailRequestId += 1;
        var requestId = detailRequestId;
        return requestJson(
          url,
          { headers: { Accept: 'application/json', Authorization: 'Bearer ' + token } },
          'detail'
        ).then(function (payload) {
          if (requestId !== detailRequestId || modal.hidden || !modalContext) return;
          var current = state.all.records[index];
          if (!current) return;
          current._source = payload.data || source;
          renderModalDetails(current, unifiedBusiness);
        }).catch(function () {
          /* The list response already contains a complete displayable record. */
        });
      },
      renderDetail: function (record, fragment) {
        var type = record._type;
        var source = record._source;
        if (type === 'license') {
          licenseBusiness.renderDetail(source, fragment);
        } else if (type === 'esim') {
          esimBusiness.renderDetail(source, fragment);
        } else if (type === 'train') {
          trainBusiness.renderDetail(source, fragment);
        }
      }
    };

    var BUSINESSES = [unifiedBusiness, licenseBusiness, esimBusiness, trainBusiness];
    var BUSINESS_BY_ID = {};
    BUSINESSES.forEach(function (desc) { BUSINESS_BY_ID[desc.id] = desc; });
    var DEFAULT_BUSINESS = BUSINESSES[0].id;

    /* ---------- State ---------- */

    function createBusinessState(phase) {
      return {
        phase: phase,
        page: 1,
        pages: 1,
        total: 0,
        records: [],
        message: '',
        email: '',
        requestId: 0
      };
    }

    function readBusinessFromUrl() {
      var business = new URL(window.location.href).searchParams.get('business');
      return BUSINESS_BY_ID[business] ? business : DEFAULT_BUSINESS;
    }

    function writeBusinessToUrl(business) {
      var url = new URL(window.location.href);
      url.searchParams.set('business', business);
      window.history.replaceState({ business: business }, '', url.toString());
    }

    var state = {
      activeBusiness: readBusinessFromUrl(),
      authUser: null,
      authReady: false,
      authBootstrapping: true,
      sharedEmail: ''
    };
    BUSINESSES.forEach(function (desc) {
      state[desc.id] = createBusinessState(desc.identity === 'login' ? 'checking' : 'idle');
    });

    var requestControllers = { license: null, esim: null, train: null, unified: null, detail: null, payment: null, refund: null };
    var modalContext = null;
    var lastModalFocus = null;
    var detailRequestId = 0;
    var paymentWatch = null;

    function activeDesc() {
      return BUSINESS_BY_ID[state.activeBusiness] || BUSINESS_BY_ID[DEFAULT_BUSINESS];
    }

    /* ---------- Email validation ---------- */

    function setEmailError(message) {
      emailInput.setAttribute('aria-invalid', message ? 'true' : 'false');
      emailError.textContent = message || '';
    }

    function validateEmail(showError) {
      var value = emailInput.value.trim();
      var message = '';
      if (!value) message = 'Enter the email address used for your order.';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) message = 'Enter a valid email address.';
      if (showError) setEmailError(message);
      return message ? '' : value;
    }

    /* ---------- Generic loader ---------- */

    async function runLoad(desc, page) {
      var st = state[desc.id];
      if (desc.identity === 'email') {
        var email = st.email;
        if (!email) {
          email = validateEmail(true);
          if (!email) { emailInput.focus(); return; }
        }
        st.email = email;
      }

      st.page = page;
      st.phase = 'loading';
      st.message = '';
      st.requestId += 1;
      var requestId = st.requestId;
      renderResults();
      syncButtons();

      try {
        var payload = await desc.request(page);
        if (requestId !== st.requestId) return;
        var parsed = desc.parse(payload, page);
        st.records = parsed.records;
        st.total = parsed.total;
        st.pages = parsed.pages;
        st.page = parsed.current || page;
        st.phase = st.records.length ? 'ready' : 'empty';
      } catch (error) {
        if (requestId !== st.requestId) return;
        st.records = [];
        var code = errorCode(error);
        if (desc.identity === 'login' && code === 401) {
          st.phase = 'auth';
          st.message = friendlyError(error, desc);
          var auth = getAuth();
          if (auth && typeof auth.signOut === 'function') auth.signOut().catch(function () {});
        } else {
          st.phase = 'error';
          st.message = friendlyError(error, desc);
        }
      }
      renderResults();
      syncButtons();
    }

    /* ---------- Auth (login identity) ---------- */

    function syncAuthState(authState) {
      var auth = getAuth();
      var nextState = authState || (auth && auth.getState());
      state.authReady = Boolean(nextState && !nextState.isLoading);
      state.authUser = nextState && nextState.isAuthenticated ? nextState.user : null;
      if (state.authUser && state.authUser.email && emailInput && !emailInput.value) {
        emailInput.value = state.authUser.email;
        state.sharedEmail = state.authUser.email;
      }
      if (!state.authUser) {
        BUSINESSES.forEach(function (desc) {
          if (desc.identity !== 'login') return;
          state[desc.id].records = [];
          state[desc.id].total = 0;
          state[desc.id].pages = 1;
          state[desc.id].phase = state.authReady ? 'auth' : 'checking';
        });
      }
      syncAuthUi();
    }

    function syncAuthUi() {
      var desc = activeDesc();
      var loggedIn = Boolean(state.authUser);
      if (accountLoginState) accountLoginState.hidden = loggedIn;
      if (accountSummary) accountSummary.hidden = !loggedIn;
      if (accountRefresh) accountRefresh.hidden = !loggedIn;
      if (loggedIn && accountEmail) accountEmail.textContent = state.authUser.email || 'your account';
      if (accountPanelTitle) accountPanelTitle.textContent = desc.resultsTitle;
      if (accountLoginTitle) accountLoginTitle.textContent = desc.accountLoginTitle || 'Log in to view your orders';
      if (accountLoginCopy) accountLoginCopy.textContent = desc.accountLoginCopy || 'Orders are linked to your account.';
      syncButtons();
    }

    function initializeAuth() {
      var auth = getAuth();
      if (!auth || typeof auth.initialize !== 'function') {
        state.authBootstrapping = false;
        state.authReady = true;
        state.authUser = null;
        BUSINESSES.forEach(function (desc) {
          if (desc.identity === 'login') state[desc.id].phase = 'auth';
        });
        syncAuthUi();
        renderResults();
        return Promise.resolve(null);
      }
      BUSINESSES.forEach(function (desc) {
        if (desc.identity === 'login') state[desc.id].phase = 'checking';
      });
      if (activeDesc().identity === 'login') renderResults();
      return auth.initialize().then(function (authState) {
        state.authBootstrapping = false;
        syncAuthState(authState);
        var desc = activeDesc();
        if (desc.identity === 'login' && state.authUser) return runLoad(desc, 1);
        renderResults();
        return state.authUser;
      }).catch(function () {
        state.authBootstrapping = false;
        state.authReady = true;
        state.authUser = null;
        BUSINESSES.forEach(function (desc) {
          if (desc.identity === 'login') state[desc.id].phase = 'auth';
        });
        syncAuthUi();
        renderResults();
        return null;
      });
    }

    /* ---------- Rendering ---------- */

    function syncButtons() {
      var desc = activeDesc();
      var current = state[desc.id];
      var loading = current.phase === 'loading';
      if (emailSubmit) {
        var emailLoading = desc.identity === 'email' && loading;
        emailSubmit.disabled = emailLoading;
        emailSubmit.textContent = emailLoading ? 'Searching…' : 'Search orders';
      }
      if (accountRefresh) {
        var accountLoading = desc.identity === 'login' && loading;
        accountRefresh.disabled = accountLoading;
        accountRefresh.textContent = accountLoading ? 'Refreshing…' : 'Refresh orders';
      }
      pagePrev.disabled = loading || current.page <= 1;
      pageNext.disabled = loading || current.page >= current.pages;
    }

    function renderResults() {
      var desc = activeDesc();
      var current = state[desc.id];
      resultsTitle.textContent = desc.resultsTitle;
      results.setAttribute('aria-busy', current.phase === 'loading' || current.phase === 'checking' ? 'true' : 'false');
      resultsStatus.replaceChildren();
      orderList.replaceChildren();
      pagination.hidden = true;

      if (current.phase === 'checking') {
        resultsSummary.textContent = 'Checking your account…';
        renderLoadingState();
      } else if (current.phase === 'loading') {
        resultsSummary.textContent = desc.loadingSummary;
        renderLoadingState();
      } else if (current.phase === 'auth') {
        var authState = desc.authState || {};
        resultsSummary.textContent = 'Login required';
        renderState('info', authState.title || 'Login required', current.message || authState.message || '', authState.actionLabel || '', authState.action || '');
      } else if (current.phase === 'error') {
        resultsSummary.textContent = 'Orders unavailable';
        renderState('error', 'We could not load these orders.', current.message, 'Try again', 'retry');
      } else if (current.phase === 'empty') {
        var empty = desc.emptyState || {};
        resultsSummary.textContent = 'No matching orders';
        renderState('info', empty.title || 'No orders found.', empty.message || '', empty.actionLabel || '', empty.action || '');
      } else if (current.phase === 'ready') {
        resultsSummary.textContent = plural(current.total || current.records.length, 'order') + ' found';
        current.records.forEach(function (record, index) {
          orderList.appendChild(renderOrderCard(record, desc, index));
        });
        renderPagination(current);
      } else {
        var idle = desc.idleState || {};
        resultsSummary.textContent = idle.summary || '';
        renderState('info', idle.title || '', idle.message || '');
      }
      syncButtons();
    }

    function renderLoadingState() {
      var wrapper = element('div', 'mo-skeleton-list');
      wrapper.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 3; i += 1) wrapper.appendChild(element('div', 'mo-skeleton'));
      resultsStatus.appendChild(element('span', 'mo-sr-only', 'Loading orders'));
      orderList.appendChild(wrapper);
    }

    function renderState(kind, title, message, actionLabel, action) {
      var stateCard = element('div', 'mo-state' + (kind === 'error' ? ' mo-state--error' : ''));
      var mark = element('span', 'mo-state__mark', kind === 'error' ? '!' : 'i');
      mark.setAttribute('aria-hidden', 'true');
      append(stateCard, mark, element('strong', '', title), element('p', '', message));
      if (actionLabel && action) {
        var button;
        var href = STATE_ACTION_HREF[action];
        if (href) {
          button = element('a', 'mo-button mo-button--primary', actionLabel);
          button.href = href;
        } else {
          button = element('button', 'mo-button mo-button--primary', actionLabel);
          button.type = 'button';
          button.dataset.stateAction = action;
        }
        stateCard.appendChild(button);
      }
      resultsStatus.appendChild(stateCard);
    }

    function renderOrderCard(record, desc, index) {
      var article = element('article', 'mo-order-card');
      var header = element('div', 'mo-order-card__header');
      var heading = element('div');
      append(
        heading,
        element('p', 'mo-order-card__service', desc.cardService(record)),
        element('h3', 'mo-order-card__title', desc.cardTitle(record))
      );
      append(header, heading, statusBadge(record, desc));
      article.appendChild(header);

      var data = element('dl', 'mo-order-card__data');
      desc.renderCard(record, data);
      article.appendChild(data);

      var alert = desc.cardAlert ? desc.cardAlert(record) : '';
      if (alert) article.appendChild(element('p', 'mo-order-alert', alert));

      var actions = element('div', 'mo-order-card__actions');
      var detailsButton = element('button', 'mo-button mo-button--secondary', 'View details');
      detailsButton.type = 'button';
      detailsButton.dataset.orderDetails = String(index);
      actions.appendChild(detailsButton);

      if (desc.cardActions) {
        var extras = desc.cardActions(record, index);
        if (extras) extras.forEach(function (node) { if (node) actions.appendChild(node); });
      }
      article.appendChild(actions);
      return article;
    }

    function renderPagination(current) {
      pagination.hidden = current.pages <= 1;
      pageLabel.textContent = 'Page ' + current.page + ' of ' + current.pages;
      pagePrev.disabled = current.page <= 1;
      pageNext.disabled = current.page >= current.pages;
    }

    function renderModalDetails(record, desc) {
      var fragment = document.createDocumentFragment();
      var header = element('header', 'mo-modal__header');
      var modalTitle = element('h2', 'mo-modal__title', desc.cardTitle(record));
      modalTitle.id = 'mo-modal-title';
      append(header, element('p', 'mo-modal__service', desc.cardService(record)), modalTitle, statusBadge(record, desc));
      fragment.appendChild(header);
      desc.renderDetail(record, fragment);
      modalContent.replaceChildren(fragment);
    }

    async function openOrderDetails(index, trigger) {
      var desc = activeDesc();
      var current = state[desc.id];
      var record = current.records[index];
      if (!record) return;
      lastModalFocus = trigger || document.activeElement;
      modalContext = { type: 'details', business: desc.id, index: index };
      modal.hidden = false;
      document.body.classList.add('mo-modal-open');
      renderModalDetails(record, desc);
      modalDialog.focus({ preventScroll: true });
      if (desc.hydrateDetail) await desc.hydrateDetail(record, index, desc);
    }

    /* ---------- Guidance ---------- */

    function updateGuidance(desc) {
      if (!orderHelp) return;
      if (desc.guidanceHTML) {
        orderHelp.innerHTML = desc.guidanceHTML;
        orderHelp.hidden = false;
      } else {
        orderHelp.replaceChildren();
        orderHelp.hidden = true;
      }
    }

    /* ---------- Switcher (custom listbox) ---------- */

    function buildSwitcherOptions() {
      if (!switcherList) return;
      switcherList.replaceChildren();
      switcherOptions = BUSINESSES.map(function (desc) {
        var li = element('li', 'mo-switcher__option');
        li.setAttribute('role', 'option');
        li.id = 'mo-switcher-option-' + desc.id;
        li.dataset.switcherOption = desc.id;
        li.tabIndex = -1;
        li.setAttribute('aria-selected', 'false');
        var icon = element('span', 'mo-switcher__option-icon');
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = desc.icon;
        var copy = element('span', 'mo-switcher__option-copy');
        append(copy, element('strong', '', desc.label), element('small', '', desc.subtitle));
        var check = element('span', 'mo-switcher__check');
        check.setAttribute('aria-hidden', 'true');
        check.innerHTML = ICON_CHECK;
        append(li, icon, copy, check);
        switcherList.appendChild(li);
        return li;
      });
    }

    function switcherIsOpen() {
      return switcherTrigger && switcherTrigger.getAttribute('aria-expanded') === 'true';
    }

    function openSwitcher() {
      if (!switcherTrigger || !switcherList || switcherIsOpen()) return;
      switcherList.hidden = false;
      switcherTrigger.setAttribute('aria-expanded', 'true');
      var selected = switcherList.querySelector('[aria-selected="true"]') || switcherOptions[0];
      if (selected) selected.focus();
    }

    function closeSwitcher(focusTrigger) {
      if (switcherTrigger) switcherTrigger.setAttribute('aria-expanded', 'false');
      if (switcherList) switcherList.hidden = true;
      if (focusTrigger && switcherTrigger) switcherTrigger.focus();
    }

    function focusOptionAt(index) {
      if (!switcherOptions.length) return;
      var i = (index + switcherOptions.length) % switcherOptions.length;
      switcherOptions[i].focus();
    }

    function selectSwitcher(id) {
      closeSwitcher(true);
      setActiveBusiness(id, true);
    }

    function updateSwitcherUi(desc) {
      if (switcherIcon) switcherIcon.innerHTML = desc.icon;
      if (switcherLabel) switcherLabel.textContent = desc.label;
      if (switcherSubtitle) switcherSubtitle.textContent = desc.subtitle;
      switcherOptions.forEach(function (option) {
        var selected = option.dataset.switcherOption === desc.id;
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
        option.classList.toggle('is-selected', selected);
      });
    }

    function initSwitcher() {
      if (!switcher || !switcherTrigger || !switcherList) return;
      buildSwitcherOptions();

      switcherTrigger.addEventListener('click', function () {
        if (switcherIsOpen()) closeSwitcher(false); else openSwitcher();
      });

      switcherTrigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openSwitcher();
        }
      });

      switcherList.addEventListener('keydown', function (event) {
        var index = switcherOptions.indexOf(document.activeElement);
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          focusOptionAt(index + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          focusOptionAt(index - 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          focusOptionAt(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          focusOptionAt(switcherOptions.length - 1);
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          var option = switcherOptions[index] || switcherOptions[0];
          if (option) selectSwitcher(option.dataset.switcherOption);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeSwitcher(true);
        } else if (event.key === 'Tab') {
          closeSwitcher(false);
        }
      });

      switcherList.addEventListener('click', function (event) {
        var option = event.target.closest('[data-switcher-option]');
        if (!option) return;
        selectSwitcher(option.dataset.switcherOption);
      });

      switcher.addEventListener('focusout', function (event) {
        if (!event.relatedTarget || !switcher.contains(event.relatedTarget)) closeSwitcher(false);
      });

      document.addEventListener('click', function (event) {
        if (!switcher.contains(event.target)) closeSwitcher(false);
      });
    }

    /* ---------- Business switching ---------- */

    function setActiveBusiness(business, updateUrl) {
      var desc = BUSINESS_BY_ID[business] || BUSINESS_BY_ID[DEFAULT_BUSINESS];
      state.activeBusiness = desc.id;
      identityPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.identityPanel !== desc.identity;
      });
      updateSwitcherUi(desc);
      updateGuidance(desc);
      if (updateUrl !== false) writeBusinessToUrl(desc.id);
      syncAuthUi();
      renderResults();
      if (desc.ensure) desc.ensure();
    }

    /* ---------- Payment watch ---------- */

    function clearPaymentWatch() {
      if (!paymentWatch) return;
      if (paymentWatch.timerId) window.clearTimeout(paymentWatch.timerId);
      if (paymentWatch.deadlineId) window.clearTimeout(paymentWatch.deadlineId);
      if (paymentWatch.popupWatchId) window.clearInterval(paymentWatch.popupWatchId);
      paymentWatch.timerId = null;
      paymentWatch.deadlineId = null;
      paymentWatch.popupWatchId = null;
      if (requestControllers.payment) requestControllers.payment.abort();
    }

    function openPayPalWindow(approveUrl) {
      var popup = window.open(
        approveUrl || '',
        '_blank',
        'popup=yes,width=1024,height=780,resizable=yes,scrollbars=yes'
      );
      if (!popup) return null;
      try {
        popup.opener = null;
        popup.focus();
      } catch (error) {
        /* Cross-origin PayPal windows may not expose all window properties. */
      }
      return popup;
    }

    function watchPayPalWindow(watch) {
      if (!watch || !watch.popup) return;
      watch.popupWatchId = window.setInterval(function () {
        if (paymentWatch !== watch) {
          window.clearInterval(watch.popupWatchId);
          watch.popupWatchId = null;
          return;
        }
        if (watch.popup && watch.popup.closed) {
          window.clearInterval(watch.popupWatchId);
          watch.popupWatchId = null;
          watch.popup = null;
          if (!watch.finished && stringValue(watch.order.status).toUpperCase() === 'PENDING_PAYMENT') {
            watch.message = 'PayPal window closed. If you already paid, we’re still checking.';
            renderPaymentModal('pending');
          }
        }
      }, 1500);
    }

    function paymentVisual(stateName) {
      var visual = element('span', 'mo-payment__visual mo-payment__visual--' + stateName);
      visual.setAttribute('aria-hidden', 'true');
      if (stateName === 'success') {
        visual.innerHTML = '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>';
      } else if (stateName === 'error') {
        visual.textContent = '!';
      } else {
        visual.appendChild(element('span', 'mo-payment__spinner'));
      }
      return visual;
    }

    function paymentAction(label, action, primary) {
      var button = element('button', 'mo-button ' + (primary ? 'mo-button--primary' : 'mo-button--secondary'), label);
      button.type = 'button';
      button.dataset.paymentAction = action;
      return button;
    }

    function paymentSteps(activeStep, completed) {
      var steps = element('ol', 'mo-payment__steps');
      var names = [
        ['payment', 'Payment'],
        ['booking', 'Booking'],
        ['ticket', 'Ticket']
      ];
      var activeIndex = names.findIndex(function (item) { return item[0] === activeStep; });
      names.forEach(function (item, index) {
        var className = 'mo-payment__step';
        if (completed || index < activeIndex) className += ' is-complete';
        else if (index === activeIndex) className += ' is-active';
        var step = element('li', className);
        append(step, element('span', 'mo-payment__step-dot', completed || index < activeIndex ? '✓' : String(index + 1)), element('span', '', item[1]));
        steps.appendChild(step);
      });
      return steps;
    }

    function renderPaymentModal(view, result) {
      if (!paymentWatch || !modalContext || modalContext.type !== 'payment') return;
      var order = result || paymentWatch.order || {};
      var isTrain = paymentWatch.business === 'train';
      var orderStatus = stringValue(order.status).toUpperCase();
      var fragment = document.createDocumentFragment();
      var body = element('div', 'mo-payment');
      var copy = element('div', 'mo-payment__copy');
      var actions = element('div', 'mo-payment__actions');
      var title;
      var description;
      var serviceLabel = 'Awaiting payment';
      var visualState = 'pending';
      var trainStep = orderStatus === 'PAID'
        ? 'booking'
        : (orderStatus === 'SUBMITTED' || orderStatus === 'WAITLIST' || orderStatus === 'TICKETED')
          ? 'ticket'
          : 'payment';

      if (view === 'success') {
        visualState = 'success';
        serviceLabel = isTrain ? 'Ticket confirmed' : 'Payment successful';
        if (isTrain) {
          title = 'Your train ticket is ready';
          description = 'Seat details are available in this order and will also be sent to your contact email.';
        } else {
          title = orderStatus === 'DELIVERED' ? 'Payment confirmed — your eSIM is ready' : 'Payment confirmed';
          description = orderStatus === 'PAID_NO_STOCK'
            ? 'Your payment was successful, but inventory is temporarily unavailable. Our support team will contact you within 24 hours.'
            : orderStatus === 'DELIVERED'
              ? 'Your eSIM has been delivered. Check the recipient email for the QR code and setup details.'
              : 'PayPal confirmed your payment. We’re now preparing the eSIM for delivery.';
        }
        actions.appendChild(paymentAction('Done', 'close', true));
      } else if (view === 'failed') {
        visualState = 'error';
        serviceLabel = 'Order update';
        title = isTrain
          ? (orderStatus === 'TICKET_FAILED' ? 'Ticketing was unsuccessful' : 'This train order needs attention')
          : 'Payment was not completed';
        description = paymentWatch.message || 'PayPal did not complete this payment. You can reopen PayPal and try again.';
        if (order.canPay && paymentWatch.approveUrl) actions.appendChild(paymentAction('Reopen PayPal', 'reopen', true));
        actions.appendChild(paymentAction('Close', 'close', false));
      } else if (view === 'timeout') {
        visualState = 'error';
        serviceLabel = isTrain ? 'Order still processing' : 'Payment update';
        title = isTrain ? 'Automatic order checking has paused' : 'Payment confirmation is taking longer than expected';
        description = isTrain
          ? 'Ticketing may still be in progress. Check again now, or close this window and follow the latest status in My Orders.'
          : 'We stopped checking automatically after 15 minutes. If you completed payment, check the status again before closing this window.';
        actions.appendChild(paymentAction('Check status', 'check', true));
        actions.appendChild(paymentAction('Close', 'close', false));
      } else {
        if (isTrain && orderStatus === 'PAID') {
          serviceLabel = 'Payment confirmed';
          title = 'Preparing your train booking';
          description = 'PayPal confirmed the payment. We’re now submitting the booking request to the ticketing team.';
        } else if (isTrain && (orderStatus === 'SUBMITTED' || orderStatus === 'WAITLIST')) {
          serviceLabel = 'Booking submitted';
          title = 'Ticketing is in progress';
          description = 'Ticketing can take from several minutes to a few hours. Keep this window open for updates, or check My Orders later.';
        } else {
          title = 'Waiting for PayPal to confirm your payment';
          description = /blocked|window closed/i.test(paymentWatch.message || '')
            ? paymentWatch.message
            : isTrain
              ? 'We opened PayPal in a new window. Finish the payment there and keep this page open for automatic booking updates.'
              : 'Complete the payment in the PayPal window. Keep this page open and the order status will update automatically.';
        }
        if (paymentWatch.approveUrl && (!paymentWatch.popup || paymentWatch.popup.closed) && order.canPay !== false) {
          actions.appendChild(paymentAction('Reopen PayPal', 'reopen', false));
        }
        actions.appendChild(paymentAction(
          isTrain && ['PAID', 'SUBMITTED', 'WAITLIST'].indexOf(orderStatus) !== -1 ? 'Close' : 'I’ll pay later',
          'close',
          false
        ));
      }

      append(
        copy,
        element('p', 'mo-modal__service', serviceLabel),
        element('h2', 'mo-modal__title', title),
        element('p', 'mo-payment__description', description)
      );
      copy.querySelector('.mo-modal__title').id = 'mo-modal-title';

      var meta = element('dl', 'mo-payment__meta');
      addFact(meta, 'Order reference', order.orderNo || order.referenceId || '—');
      addFact(meta, 'Total', formatCurrency(pick(order, ['totalUsd', 'totalPrice']), order.currency) || '—', 'mo-order-fact--price');

      append(body, paymentVisual(visualState), copy, meta);
      if (isTrain) body.appendChild(paymentSteps(trainStep, view === 'success'));
      body.appendChild(actions);
      fragment.appendChild(body);
      modalContent.replaceChildren(fragment);
      paymentWatch.renderedView = view;
      paymentWatch.renderedStatus = orderStatus;
    }

    function paymentFailureMessage(status) {
      if (status === 'CANCELLED' || status === 'CANCELED') return 'PayPal reported that the payment was cancelled. No charge was made.';
      if (status === 'TICKET_FAILED') return 'Ticketing was unsuccessful. A refund request is created automatically for failed tickets.';
      if (status === 'SUBMIT_FAILED') return 'Payment was received, but the booking could not be submitted. Our team will review the order.';
      if (status === 'REFUND_FAILED') return 'The refund needs attention from our support team.';
      if (status === 'REFUNDED') return 'This order has been refunded.';
      return 'The PayPal payment link has expired. No charge was made.';
    }

    function mergeConfirmedOrder(existing, result) {
      var merged = Object.assign({}, existing || {}, result || {});
      if (result && result.status) {
        merged.statusLabelEn = result.statusLabelEn || enumLabel(result.status);
      }
      return merged;
    }

    function syncWatchedOrder(watch, result, shouldRender) {
      if (!watch || !result) return;
      var st = state[watch.business];
      if (!st) return;
      var orderNo = stringValue(result.orderNo || watch.order.orderNo);
      var index = watch.index;
      if (!st.records[index] || stringValue(st.records[index].orderNo) !== orderNo) {
        index = st.records.findIndex(function (record) { return stringValue(record.orderNo) === orderNo; });
      }
      watch.order = mergeConfirmedOrder(watch.order, result);
      if (index !== -1 && st.records[index]) {
        st.records[index] = mergeConfirmedOrder(st.records[index], result);
        watch.index = index;
      }
      if (shouldRender && state.activeBusiness === watch.business && st.phase === 'ready') renderResults();
    }

    function refreshOrdersAfterPayment(watch, result) {
      if (!watch) return;
      syncWatchedOrder(watch, result, true);
      var desc = BUSINESS_BY_ID[watch.business];
      var st = state[watch.business];
      if (!desc || !st) return;
      runLoad(desc, st.page || 1).then(function () {
        if (!result || st.phase !== 'ready') return;
        syncWatchedOrder(watch, result, state.activeBusiness === watch.business);
      });
    }

    function paymentStatusUrl(watch) {
      var orderNo = encodeURIComponent(watch.order.orderNo);
      return watch.business === 'train'
        ? trainApi + '/orders/' + orderNo
        : esimApi + '/api/v1/esim/orders/' + orderNo;
    }

    function closePaymentPopup(watch) {
      if (!watch) return;
      if (watch.popupWatchId) {
        window.clearInterval(watch.popupWatchId);
        watch.popupWatchId = null;
      }
      if (watch.popup && !watch.popup.closed) {
        try { watch.popup.close(); } catch (error) { /* Ignore browser cleanup errors. */ }
      }
      watch.popup = null;
    }

    async function pollPaymentStatus(isManualCheck) {
      var watch = paymentWatch;
      if (!watch || watch.finished) return;
      if (watch.timerId) window.clearTimeout(watch.timerId);
      watch.timerId = null;
      watch.message = isManualCheck ? 'Checking the latest order status…' : 'Checking payment status…';

      var token = getAccessToken();
      if (!token) {
        watch.finished = true;
        clearPaymentWatch();
        watch.message = 'Your session expired while checking this order. Log in again to confirm its status.';
        renderPaymentModal('failed');
        return;
      }

      try {
        var payload = await requestJson(
          paymentStatusUrl(watch),
          { headers: { Accept: 'application/json', Authorization: 'Bearer ' + token } },
          'payment'
        );
        if (paymentWatch !== watch || watch.finished) return;
        var result = payload.data || watch.order;
        var previousStatus = stringValue(watch.order.status).toUpperCase();
        var status = stringValue(result.status).toUpperCase();
        var statusChanged = previousStatus !== status;
        result.status = status;
        syncWatchedOrder(watch, result, statusChanged);
        /* Money is captured at PAID for both business lines. Train orders only reach
           TICKETED hours later, so reporting the conversion here keeps a resumed
           payment from being lost. trackPurchase dedupes on order number, so the
           same order paid on its own page is not counted twice. */
        if (['PAID', 'DELIVERED', 'PAID_NO_STOCK', 'SUBMITTED', 'WAITLIST', 'TICKETED']
              .indexOf(status) !== -1 && window.tcng) {
          var currentOrderNo = stringValue(result.orderNo) || stringValue(watch.order.orderNo);
          var businessState = state[watch.business];
          var paidStatuses = ['PAID', 'DELIVERED', 'PAID_NO_STOCK', 'SUBMITTED', 'WAITLIST', 'TICKETED'];
          var otherPaidOrders = (businessState && businessState.records || []).filter(function (r) {
            var rNo = stringValue(r.orderNo);
            return rNo && rNo !== currentOrderNo && paidStatuses.indexOf(stringValue(r.status).toUpperCase()) !== -1;
          });
          var isNewCustomer = otherPaidOrders.length === 0;

          window.tcng.trackPurchase({
            orderNo: currentOrderNo,
            value: pick(result, ['totalUsd', 'totalPrice']) ||
              pick(watch.order, ['totalUsd', 'totalPrice']),
            currency: result.currency || watch.order.currency || 'USD',
            businessLine: watch.business === 'train' ? 'train' : 'esim_paid',
            items: [],
            new_customer: isNewCustomer
          });
        }

        var paymentSucceeded = watch.business === 'train'
          ? status === 'TICKETED'
          : ['PAID', 'DELIVERED', 'PAID_NO_STOCK'].indexOf(status) !== -1;
        var paymentFailed = watch.business === 'train'
          ? ['TICKET_FAILED', 'SUBMIT_FAILED', 'EXPIRED', 'CANCELLED', 'CANCELED', 'REFUNDED', 'REFUND_FAILED'].indexOf(status) !== -1 ||
            (status === 'PENDING_PAYMENT' && result.paymentExpired)
          : ['CANCELLED', 'CANCELED', 'EXPIRED', 'REFUNDED'].indexOf(status) !== -1 ||
            (status === 'PENDING_PAYMENT' && result.paymentExpired);

        if (paymentSucceeded) {
          watch.finished = true;
          closePaymentPopup(watch);
          clearPaymentWatch();
          renderPaymentModal('success', result);
          refreshOrdersAfterPayment(watch, result);
          try { window.focus(); } catch (focusError) { /* ignore */ }
          return;
        }
        if (paymentFailed) {
          watch.finished = true;
          closePaymentPopup(watch);
          clearPaymentWatch();
          watch.message = stringValue(result.failReason) || paymentFailureMessage(status);
          renderPaymentModal('failed', result);
          refreshOrdersAfterPayment(watch, result);
          return;
        }
        if (watch.business === 'train' && ['PAID', 'SUBMITTED', 'WAITLIST'].indexOf(status) !== -1) {
          closePaymentPopup(watch);
          watch.message = result.statusDesc || (status === 'PAID' ? 'Payment received, preparing to book' : 'Booking in progress');
        } else {
          watch.message = 'Waiting for PayPal to confirm payment…';
        }
      } catch (error) {
        if (paymentWatch !== watch || watch.finished) return;
        var code = errorCode(error);
        if (code === 401 || code === 403 || code === 404) {
          watch.finished = true;
          clearPaymentWatch();
          watch.message = code === 401
            ? 'Your session expired while checking this order. Log in again to confirm its status.'
            : 'We could not access this order. Refresh My Orders or contact support.';
          renderPaymentModal('failed');
          return;
        }
        watch.message = 'Connection interrupted. Retrying in a moment…';
      }

      if (isManualCheck) {
        renderPaymentModal('timeout');
        return;
      }

      var currentStatus = stringValue(watch.order.status).toUpperCase();
      if (watch.renderedView !== 'pending' || watch.renderedStatus !== currentStatus) {
        renderPaymentModal('pending');
      }
      if (paymentWatch === watch && !watch.finished) {
        var pollInterval = watch.business === 'train' && ['PAID', 'SUBMITTED', 'WAITLIST'].indexOf(stringValue(watch.order.status).toUpperCase()) !== -1
          ? TRAIN_TICKETING_POLL_INTERVAL
          : PAYMENT_POLL_INTERVAL;
        watch.timerId = window.setTimeout(pollPaymentStatus, pollInterval);
      }
    }

    function beginPaymentWait(index, trigger) {
      var desc = activeDesc();
      var order = state[desc.id].records[index];
      if (!order || !order.orderNo) return;
      var approveUrl = desc.id === 'train' ? paypalUrl(order.approveUrl) : safeHttpUrl(order.approveUrl);
      if (!approveUrl) return;

      clearPaymentWatch();
      if (window.tcng) {
        window.tcng.track('add_payment_info', {
          business_line: desc.id === 'train' ? 'train' : 'esim_paid',
          transaction_id: stringValue(order.orderNo),
          value: Number(pick(order, ['totalUsd', 'totalPrice'])) || 0,
          currency: order.currency || 'USD',
          payment_type: 'PayPal',
          resumed_payment: 'yes'
        });
      }
      var popup = openPayPalWindow(approveUrl);
      paymentWatch = {
        order: order,
        business: desc.id,
        index: index,
        approveUrl: approveUrl,
        popup: popup,
        popupWatchId: null,
        timerId: null,
        deadlineId: null,
        finished: false,
        renderedView: '',
        renderedStatus: '',
        message: popup ? 'Checking payment status…' : 'Your browser blocked the PayPal window. Select Reopen PayPal to try again.'
      };
      lastModalFocus = trigger || document.activeElement;
      modalContext = { type: 'payment', business: desc.id, index: index };
      modal.hidden = false;
      document.body.classList.add('mo-modal-open');
      modalClose.setAttribute('aria-label', 'Close payment status');
      renderPaymentModal('pending');
      modalDialog.focus({ preventScroll: true });

      if (popup) watchPayPalWindow(paymentWatch);
      paymentWatch.deadlineId = window.setTimeout(function () {
        if (!paymentWatch || paymentWatch.finished) return;
        paymentWatch.finished = true;
        clearPaymentWatch();
        renderPaymentModal('timeout');
      }, desc.id === 'train' ? TRAIN_PAYMENT_POLL_TIMEOUT : PAYMENT_POLL_TIMEOUT);
      pollPaymentStatus(false);
    }

    function reopenPaymentWindow() {
      var watch = paymentWatch;
      if (!watch || !watch.approveUrl) return;
      var popup = openPayPalWindow(watch.approveUrl);
      if (!popup) {
        watch.message = 'Your browser blocked the PayPal window. Allow pop-ups and try again.';
        renderPaymentModal('pending');
        return;
      }
      watch.popup = popup;
      watch.message = 'Checking payment status…';
      if (!watch.popupWatchId) watchPayPalWindow(watch);
      renderPaymentModal('pending');
    }

    /* ---------- Train refunds ---------- */

    function refundAction(label, action, primary) {
      var button = element('button', 'mo-button ' + (primary ? 'mo-button--primary' : 'mo-button--secondary'), label);
      button.type = 'button';
      button.dataset.refundAction = action;
      return button;
    }

    function refundAmount(value) {
      return formatCurrency(value, 'USD') || '—';
    }

    function renderRefundLoading() {
      var body = element('div', 'mo-refund mo-refund--centered');
      var title = element('h2', 'mo-modal__title', 'Calculating your refund');
      title.id = 'mo-modal-title';
      append(
        body,
        paymentVisual('pending'),
        element('p', 'mo-modal__service', 'Train ticket refund'),
        title,
        element('p', 'mo-refund__intro', 'Checking the latest railway fees and refundable balance…')
      );
      modalContent.replaceChildren(body);
    }

    function renderRefundError(error) {
      if (!modalContext || modalContext.type !== 'refund') return;
      var body = element('div', 'mo-refund mo-refund--centered');
      var title = element('h2', 'mo-modal__title', 'We could not calculate this refund');
      var actions = element('div', 'mo-refund__actions');
      title.id = 'mo-modal-title';
      append(actions, refundAction('Try again', 'retry', true), refundAction('Close', 'close', false));
      append(
        body,
        paymentVisual('error'),
        element('p', 'mo-modal__service', 'Train ticket refund'),
        title,
        element('p', 'mo-refund__intro', friendlyError(error, trainBusiness)),
        actions
      );
      modalContent.replaceChildren(body);
    }

    function refundBreakdown(preview) {
      var list = element('dl', 'mo-refund__breakdown');
      var rows = [
        ['Amount paid', refundAmount(preview.paidUsd)],
        ['Refundable before fees', refundAmount(preview.grossUsd)],
        ['Platform handling fee', preview.feeWaived ? 'Waived' : '−' + refundAmount(preview.handlingFeeUsd)],
        ['Railway cancellation fee', preview.feeWaived ? 'Waived' : '−' + refundAmount(preview.railwayFeeUsd)],
        ['Estimated refund', refundAmount(preview.netRefundUsd), 'mo-refund__row--total']
      ];
      rows.forEach(function (row) {
        var item = element('div', 'mo-refund__row' + (row[2] ? ' ' + row[2] : ''));
        append(item, element('dt', '', row[0]), element('dd', '', row[1]));
        list.appendChild(item);
      });
      return list;
    }

    function renderRefundPreview(record, preview) {
      if (!modalContext || modalContext.type !== 'refund') return;
      modalContext.preview = preview;
      var body = element('div', 'mo-refund');
      var header = element('header', 'mo-modal__header');
      var title = element('h2', 'mo-modal__title', 'Review your refund');
      title.id = 'mo-modal-title';
      append(
        header,
        element('p', 'mo-modal__service', 'High-speed rail'),
        title,
        element('p', 'mo-refund__intro', 'Order #' + record.orderNo)
      );
      append(body, header, refundBreakdown(preview));

      var feeNote = [];
      if (preview.tierDesc) feeNote.push(preview.tierDesc);
      if (preview.railwayFeeCny !== undefined && preview.railwayFeeCny !== null) {
        feeNote.push('Railway fee ' + formatCurrency(preview.railwayFeeCny, 'CNY'));
      }
      if (feeNote.length) body.appendChild(element('p', 'mo-refund__fee-note', feeNote.join(' · ')));

      var policyNote = element('p', 'mo-refund__policy');
      var policyLink = element('a', '', 'View the official 12306 refund and change policy ↗');
      policyLink.href = TRAIN_REFUND_POLICY_URL;
      policyLink.target = '_blank';
      policyLink.rel = 'noopener noreferrer';
      append(
        policyNote,
        document.createTextNode('Refund fees are calculated under China Railway rules. '),
        policyLink
      );
      body.appendChild(policyNote);

      if (!preview.refundable) {
        body.appendChild(element('p', 'mo-order-alert mo-refund__blocked', preview.blockReason || 'This order is not currently refundable.'));
        var blockedActions = element('div', 'mo-refund__actions');
        blockedActions.appendChild(refundAction('Close', 'close', true));
        body.appendChild(blockedActions);
        modalContent.replaceChildren(body);
        return;
      }

      var form = element('form', 'mo-refund__form');
      form.dataset.refundForm = '';
      form.noValidate = true;
      var field = element('div', 'mo-field');
      var label = element('label', '', 'Reason for refund');
      label.htmlFor = 'mo-refund-reason';
      var textarea = document.createElement('textarea');
      textarea.id = 'mo-refund-reason';
      textarea.name = 'reason';
      textarea.rows = 4;
      textarea.maxLength = 500;
      textarea.placeholder = 'Tell us why you need to cancel this trip';
      textarea.required = true;
      textarea.setAttribute('aria-describedby', 'mo-refund-help mo-refund-error');
      var help = element('span', 'mo-field__help', 'The final amount is recalculated when you submit and requires manual approval, usually within one business day.');
      help.id = 'mo-refund-help';
      var error = element('span', 'mo-field__error');
      error.id = 'mo-refund-error';
      error.dataset.refundError = '';
      error.setAttribute('role', 'alert');
      append(field, label, textarea, help, error);

      var actions = element('div', 'mo-refund__actions');
      var submit = element('button', 'mo-button mo-button--primary', 'Submit refund request');
      submit.type = 'submit';
      submit.dataset.refundSubmit = '';
      append(actions, submit, refundAction('Keep order', 'close', false));
      append(form, field, actions);
      body.appendChild(form);
      modalContent.replaceChildren(body);
      textarea.focus({ preventScroll: true });
    }

    function renderRefundSubmitted(record, request) {
      var body = element('div', 'mo-refund mo-refund--centered');
      var title = element('h2', 'mo-modal__title', 'Your refund request is under review');
      var meta = element('dl', 'mo-payment__meta');
      var actions = element('div', 'mo-refund__actions');
      title.id = 'mo-modal-title';
      addFact(meta, 'Order reference', record.orderNo || '—');
      addFact(meta, 'Estimated refund', refundAmount(request.requestAmount), 'mo-order-fact--price');
      actions.appendChild(refundAction('Done', 'close', true));
      append(
        body,
        paymentVisual('success'),
        element('p', 'mo-modal__service', 'Refund requested'),
        title,
        element('p', 'mo-refund__intro', 'Our team usually reviews requests within one business day. Approved refunds are returned to the original PayPal account.'),
        meta,
        actions
      );
      modalContent.replaceChildren(body);
    }

    function loadRefundPreview(context) {
      if (!context || modalContext !== context) return;
      var token = getAccessToken();
      if (!token) {
        renderRefundError(apiError('Log in again to request a refund.', 401, 401));
        return;
      }
      renderRefundLoading();
      requestJson(
        trainApi + '/orders/' + encodeURIComponent(context.orderNo) + '/refund-preview',
        { headers: { Accept: 'application/json', Authorization: 'Bearer ' + token } },
        'refund'
      ).then(function (payload) {
        if (modalContext !== context || modal.hidden) return;
        renderRefundPreview(context.record, payload.data || {});
      }).catch(function (error) {
        if (modalContext !== context || modal.hidden) return;
        renderRefundError(error);
      });
    }

    function openRefundPreview(index, trigger) {
      var record = state.train.records[index];
      if (!record || !record.orderNo || !record.canRefund || record.refundUnderReview) return;
      lastModalFocus = trigger || document.activeElement;
      modalContext = { type: 'refund', business: 'train', index: index, orderNo: record.orderNo, record: record, preview: null };
      modal.hidden = false;
      document.body.classList.add('mo-modal-open');
      modalClose.setAttribute('aria-label', 'Close refund request');
      loadRefundPreview(modalContext);
      modalDialog.focus({ preventScroll: true });
    }

    function submitTrainRefund(form) {
      var context = modalContext;
      if (!context || context.type !== 'refund' || !context.preview || !context.preview.refundable) return;
      var reasonInput = form.querySelector('[name="reason"]');
      var errorNode = form.querySelector('[data-refund-error]');
      var submit = form.querySelector('[data-refund-submit]');
      var reason = stringValue(reasonInput && reasonInput.value);
      if (!reason) {
        if (errorNode) errorNode.textContent = 'Enter a reason for your refund request.';
        if (reasonInput) reasonInput.focus();
        return;
      }
      if (errorNode) errorNode.textContent = '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Submitting…';
      }
      var token = getAccessToken();
      if (!token) {
        renderRefundError(apiError('Your session has expired. Log in again to request a refund.', 401, 401));
        return;
      }
      requestJson(
        trainApi + '/orders/' + encodeURIComponent(context.orderNo) + '/refund',
        {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
          body: JSON.stringify({
            orderNo: context.orderNo,
            reason: reason,
            amount: null,
            email: context.record.contactEmail || (state.authUser && state.authUser.email) || ''
          })
        },
        'refund'
      ).then(function (payload) {
        if (modalContext !== context || modal.hidden) return;
        var request = payload.data || {};
        var updated = Object.assign({}, context.record, {
          status: 'REFUND_PENDING',
          statusDesc: 'Refund under review',
          canRefund: false,
          refundUnderReview: true
        });
        state.train.records[context.index] = updated;
        context.record = updated;
        renderRefundSubmitted(updated, request);
        if (state.activeBusiness === 'train' && state.train.phase === 'ready') renderResults();
        runLoad(trainBusiness, state.train.page || 1);
      }).catch(function (error) {
        if (modalContext !== context || modal.hidden) return;
        if (errorNode) errorNode.textContent = friendlyError(error, trainBusiness);
        if (submit) {
          submit.disabled = false;
          submit.textContent = 'Submit refund request';
        }
        if (errorCode(error) === 409) runLoad(trainBusiness, state.train.page || 1);
      });
    }

    function closeModal() {
      if (modal.hidden) return;
      if (modalContext && modalContext.type === 'payment') {
        clearPaymentWatch();
        paymentWatch = null;
      }
      detailRequestId += 1;
      if (requestControllers.detail) requestControllers.detail.abort();
      if (requestControllers.refund) requestControllers.refund.abort();
      modal.hidden = true;
      modalContext = null;
      modalClose.setAttribute('aria-label', 'Close order details');
      document.body.classList.remove('mo-modal-open');
      if (lastModalFocus && typeof lastModalFocus.focus === 'function') lastModalFocus.focus();
      lastModalFocus = null;
    }

    function trapModalFocus(event) {
      if (event.key !== 'Tab' || modal.hidden) return;
      var focusable = modalDialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* ---------- Event bindings ---------- */

    initSwitcher();

    emailForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = validateEmail(true);
      if (!email) {
        emailInput.focus();
        return;
      }
      state.sharedEmail = email;
      var desc = activeDesc();
      if (desc.identity !== 'email') return;
      state[desc.id].email = email;
      state[desc.id].page = 1;
      runLoad(desc, 1);
    });

    emailInput.addEventListener('blur', function () {
      if (emailInput.value.trim()) validateEmail(true);
    });

    emailInput.addEventListener('input', function () {
      if (emailInput.getAttribute('aria-invalid') === 'true') setEmailError('');
    });

    if (accountLoginButton) {
      accountLoginButton.addEventListener('click', function () {
        var auth = getAuth();
        if (!auth || typeof auth.requireLogin !== 'function') return;
        auth.requireLogin().then(function (user) {
          if (!user) return;
          syncAuthState(auth.getState());
          var desc = activeDesc();
          if (desc.identity === 'login' && state[desc.id].phase !== 'loading') runLoad(desc, 1);
        });
      });
    }

    if (accountRefresh) {
      accountRefresh.addEventListener('click', function () {
        var desc = activeDesc();
        if (desc.identity === 'login') runLoad(desc, state[desc.id].page || 1);
      });
    }

    resultsStatus.addEventListener('click', function (event) {
      var action = event.target.closest('[data-state-action]');
      if (!action) return;
      if (action.dataset.stateAction === 'login' && accountLoginButton) accountLoginButton.click();
      if (action.dataset.stateAction === 'retry') {
        var desc = activeDesc();
        desc.load(state[desc.id].page || 1);
      }
    });

    orderList.addEventListener('click', function (event) {
      var paymentTrigger = event.target.closest('[data-order-payment]');
      if (paymentTrigger) {
        beginPaymentWait(Number(paymentTrigger.dataset.orderPayment), paymentTrigger);
        return;
      }
      var refundTrigger = event.target.closest('[data-order-refund]');
      if (refundTrigger) {
        openRefundPreview(Number(refundTrigger.dataset.orderRefund), refundTrigger);
        return;
      }
      var trigger = event.target.closest('[data-order-details]');
      if (!trigger) return;
      openOrderDetails(Number(trigger.dataset.orderDetails), trigger);
    });

    modalContent.addEventListener('click', function (event) {
      var action = event.target.closest('[data-payment-action]');
      if (action) {
        if (action.dataset.paymentAction === 'close') closeModal();
        if (action.dataset.paymentAction === 'reopen') reopenPaymentWindow();
        if (action.dataset.paymentAction === 'check' && paymentWatch) {
          paymentWatch.finished = false;
          pollPaymentStatus(true);
        }
        return;
      }
      var refundActionButton = event.target.closest('[data-refund-action]');
      if (!refundActionButton) return;
      if (refundActionButton.dataset.refundAction === 'close') closeModal();
      if (refundActionButton.dataset.refundAction === 'retry' && modalContext && modalContext.type === 'refund') {
        loadRefundPreview(modalContext);
      }
    });

    modalContent.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-refund-form]');
      if (!form) return;
      event.preventDefault();
      submitTrainRefund(form);
    });

    pagePrev.addEventListener('click', function () {
      var desc = activeDesc();
      var current = state[desc.id];
      if (current.page <= 1) return;
      desc.load(current.page - 1);
    });

    pageNext.addEventListener('click', function () {
      var desc = activeDesc();
      var current = state[desc.id];
      if (current.page >= current.pages) return;
      desc.load(current.page + 1);
    });

    modalClose.addEventListener('click', closeModal);
    modalDialog.addEventListener('keydown', trapModalFocus);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    document.addEventListener('tripcn:auth-change', function (event) {
      syncAuthState(event.detail);
      if (state.authBootstrapping) {
        renderResults();
        return;
      }
      var desc = activeDesc();
      if (desc.identity === 'login' && state.authUser && state[desc.id].phase !== 'loading') {
        runLoad(desc, 1);
      } else {
        renderResults();
      }
    });

    window.addEventListener('popstate', function () {
      setActiveBusiness(readBusinessFromUrl(), false);
    });

    setActiveBusiness(state.activeBusiness, false);
    initializeAuth();
  });
})();
